import { attr, fk } from 'redux-orm';

import BaseModel from './BaseModel';
import ActionTypes from '../constants/ActionTypes';

export default class extends BaseModel {
  static modelName = 'CardPointAdvancedData';

  static fields = {
    id: attr(),
    cardId: fk({
      to: 'Card',
      as: 'card',
      relatedName: 'cardPointAdvancedDatas',
    }),
    pointSistemId: fk({
      to: 'PointSystem',
      as: 'pointSystem',
      relatedName: 'cardPointAdvancedDatas',
    }),
    value: attr(),
    description: attr(),
  };

  static reducer({ type, payload }, CardPointAdvancedData) {
    switch (type) {
      case ActionTypes.CARD_POINT_ADVANCED_DATA_FETCH__SUCCESS: {
        const { cardId, pointSystemId, items } = payload;

        CardPointAdvancedData.filter({ cardId, pointSistemId: pointSystemId }).delete();
        items.forEach((item) => CardPointAdvancedData.upsert(item));

        break;
      }
      case ActionTypes.CARD_POINT_ADVANCED_DATA_CREATE__SUCCESS:
      case ActionTypes.CARD_POINT_ADVANCED_DATA_UPDATE__SUCCESS:
        CardPointAdvancedData.upsert(payload.item);

        break;
      case ActionTypes.CARD_POINT_ADVANCED_DATA_DELETE__SUCCESS:
        CardPointAdvancedData.withId(payload.item.id)?.delete();

        break;
      default:
    }
  }
}

